<template>
  <div>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <!-- <div class="filters margin-b-25px">
      <tl-select
        label="From"
        :value="filter.from"
        :options="monthList"
        @change="(val)=>filter.from = val"
        :disabled="true"
      />
      <tl-select
        label="To"
        :value="filter.to"
        :options="monthList"
        @change="(val)=>filter.to = val"
        :disabled="true"
      />
    </div> -->
    <div class="filters margin-t-25px" :disabled="!ifTeamleaderAnchorPermission">
      <tl-select
        label="PayGroup"
        labelText="name"
        :options="payGroupData"
        v-model="filterData.paygroupId"
        @change="(val)=>filterData.paygroupId = val"
      />
      <tl-select
        label="Criteria"
        labelText="name"
        :options="criteriaList"
        v-model="criteria"
        @change="(val) => {criteria = val;onChangeCriteria(val)}"
      />
      <tl-select
        label="SubCriteria"
        labelText="name"
        :options="subCriteriaList"
        v-model="subCriteria"
        :multiple="true"
        @change="(val) => {subCriteria = val;}"
      />
      <!-- <tl-select
        label="Status"
        labelText="name"
        :options="statusList"
        @change="(val)=>filterData.status = val ? val.name : null"
        :disabled="true"
      /> -->
    </div>
    <btn class="margin-tb-25px" type="secondary" text="Apply Filters" @click="applyFilters"  :disabled="!ifTeamleaderAnchorPermission"/>
    <tl-search class="margin-b-25px" @change="filterOnChange($event)" @blur="filterOnblur($event)" :disabled="!ifTeamleaderAnchorPermission"></tl-search>

    <!-- <div> {{firstPage ? 1 : employeeData.length == 100 ? ((employeeData.length)(currentPage - 1) + 1) : ((100)*(currentPage - 1) + 1)&nbsp; }} - &nbsp;{{(employeeData.length == 100 ? (employeeData.length)*(currentPage) : totalEmployees)}}/&nbsp;{{totalEmployees}}</div> -->
    <div v-if="employeeData.length">{{ employeePageCount }}</div>
    <div class="table-div" ref="table_div" @scroll="onScroll()" :disabled="!ifTeamleaderAnchorPermission">
      <data-table
        :columns="columnNames"
        :tableData="employeeData"
        :checkbox="true"
        :showinrow="false"
        :with-form="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key=='code'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='currCtc'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='totRevision'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <!-- dropdown section starts here -->
          <div v-if="slotprops.value.column.key=='reviseSalary'">
            <div
              class="margin-t-xs"
              v-for="(obj,index) of slotprops.value.record[slotprops.value.column.key]"
              :key="index"
            >
              <span>{{obj}}</span>
            </div>
          </div>
          <div v-if="slotprops.value.column.key=='effectiveDate'">
            <div
              class="margin-t-xs"
              v-for="(obj,index) of slotprops.value.record[slotprops.value.column.key]"
              :key="index"
            >
              <span>{{obj}}</span>
            </div>
          </div>
          <div class="action-section" v-if="slotprops.value.column.key=='action'">
            <img
              src="@/assets/group-2.png"
              class="pointer-cursor"
              @click="dropdown(slotprops.value.record)"
              alt="actionIcon"
            />
            <ul class="action-menu" v-show="employeeData[slotprops.value.index].showDropDown">
              <li>
                <span class @click="reviseseSalary(slotprops.value.record)">Revise Salary</span>
              </li>
              <li>
                <span class @click="RevokeReviseSalary(slotprops.value.record)">Revoke Revision</span>
              </li>
              <li>
                <span class @click="viewHistory(slotprops.value.record)">View History</span>
              </li>
            </ul>
          </div>
        </template>
      </data-table>
    </div>
    <div v-if="employeeData.length">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        Previous 
      </button>
      <span> {{ currentPage }} of {{ totalPages }} </span>
      <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
        Next 
      </button>
    </div>

    <div class="modal" v-if="showWarningMsg" >
      <div class="modal-content">
        <div class="success-icon">
          <img src="@/assets/warning_error.svg" />
        </div>
        <div class="success-text">
          <b>Are you sure you wish to make changes ?</b>
        </div>
        <div class="message-text">
          This action cannot be UNDO once processed
        </div>
        <div class="popup-btns">
          <btn text="Cancel" type="secondary" @click="cancel" />
          <btn text="Confirm" type="primary" @click="confirm" />
        </div>
      </div>
    </div>


    <pop-up-message
      v-if="showRevokeRevisePopup"
      message=""
      popupType="Success"
      :popupHeaderMessage="'REVOKE SALARY REVISION SUCCESS !!!'"
      btnText="Back To Revision History"
      @back="backToSalaryDataPage"

    ></pop-up-message>
     <pop-up-message
      v-if="failuremsg"
      message=""
      popupType="Failure"
      :popupHeaderMessage="'REVOKE SALARY REVISION FAILED !!!'"
      btnText="Back To Revision History"
      @back="backToSalaryDataPage"

    ></pop-up-message>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import * as constants from "@/apis/constants.js";

export default {
  data() {
    return {
      page: 1,
      currentPage: 1,
      employeePageCount: "",
      tempArrayList: [],
      totalPages: 0,
      itemsPerPage: 100,
      totalEmployees: 0,
      firstPage: true,
      criteria: null,
      subCriteria: [],
      uploadMethod: "manualUpload",
      masterSalaryData: [],
      monthList: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      criteriaList: [],
      subCriteriaList: [],
      statusList: [],
      filterData: {
        paygroupId: null,
        criteriaObj: null,
        subCriteriaObj: [],
        status: ""
      },
      filter: {
        from: "",
        to: ""
      },
      columnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        // {
        //   label: "Base Salary",
        //   key: "currCtc"
        // },
        {
          label: "Total Revision",
          key: "totRevision"
        },
        {
          label: "Revised Salary",
          key: "reviseSalary"
        },
        // {
        //   label: "Revised Date/s",
        //   key: "effectiveDate"
        // },
        // {
        //   label: "Status",
        //   key: "status"
        // },
        {
          label: "Effective Date/s",
          key: "effectiveDate"
        },
        {
          label: "Actions",
          key: "action"
        }
      ],

      searchText: "",
      employeeData: [],
      revisesalaryList: [{}],
      applyToOptions: [],
      revisedByOptions: [],
      locationList: [],
      bandList: [],
      designationList: [],
      gradeList: [],
      payGroupData: [],
      showRevokeRevisePopup:false,
      showWarningMsg:false,
      tempRecord:null,
      failuremsg:false,
      reviseSalaryValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.reviseSalaryValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  mounted() {
    this.refresh();
    this.setConstantsData();
    this.fetchAllPaygroups();
    this.getOrgLeIdList();
  },
  activated() {
    this.uploadMethod = "manualUpload";
    this.refresh();
    this.setConstantsData();
    this.fetchAllPaygroups();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_empCategories: "onboard/empCategory/fetchAll",
      fetch_filtered_employees:
        "dashboard/payroll/utilities/revisesalary/fetchFilteredEmployeesList",
        act_revoke_revise_salary:"dashboard/payroll/utilities/revisesalary/RevokeReviseSalary",
      fetch_searched_employee: 'dashboard/payroll/utilities/revisesalary/getSearchedEmployees'
    }),

    refresh() {
      this.page = 1;
      this.criteria = null;
      this.subCriteria = [];
      this.employeeData = [];
    },

    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchEployees();
      }
    },

    async applyFilters() {
      try {
        this.employeeData = [];
        this.employeeData = [...this.employeeData];
        this.page = 1;
        this.fetchEployees();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchEployees() {
      let selectedSubCriteriaList = [];
      if (this.criteria && this.criteria.name) {
        if (this.subCriteria.length) {
          this.subCriteria.forEach(item => {
            selectedSubCriteriaList.push(item.id);
          });
        }
      }
      let objRequest = {
        le_id: this.le_id,
        paygroups: this.filterData.paygroupId.id
          ? [this.filterData.paygroupId.id]
          : [],
        bands:
          this.criteria && this.criteria.name == "Bands"
            ? selectedSubCriteriaList
            : [],
        designations:
          this.criteria && this.criteria.name == "Designation"
            ? selectedSubCriteriaList
            : [],
        locs:
          this.criteria && this.criteria.name == "Location"
            ? selectedSubCriteriaList
            : [],
        grades:
          this.criteria && this.criteria.name == "Grades"
              ? selectedSubCriteriaList
              : [],
        page: this.currentPage
      };
      let res = await this.fetch_filtered_employees(objRequest);
      this.employeeData = [];
      this.tempArrayList = [];
      if (res.data.status) {
        let empList = [];
        this.totalEmployees = res.data.payload.totalEmpCount;
        this.totalPages = Math.ceil(this.totalEmployees/this.itemsPerPage);
        for (let employee of res.data.payload.data) {
          (employee["name"] = employee.first_name),
            (employee["code"] = employee.code),
            (employee["email"] = employee.email_id),
            (employee["showDropDown"] = false);
          employee["empSalarySettings"] = employee.EmployeeSalarySetting;
          employee["email"] = employee.email_id;
          employee["currCtc"] =
            employee.EmployeeSalarySetting[0].master_salary_structure.ctc;
          if (employee.EmployeeSalarySetting[0].history_salary_structure) {
            employee["totRevision"] =
              employee.EmployeeSalarySetting[0].history_salary_structure.length;
            employee["reviseSalary"] = [];
            employee["effectiveDate"] = [];
            for (let historyObj of employee.EmployeeSalarySetting[0]
              .history_salary_structure) {
              employee["reviseSalary"].push(historyObj.ctc);
              employee["effectiveDate"].push(historyObj.from);
            }
          }
          empList.push(employee);
        }
        this.employeeData.push(...empList);
        this.tempArrayList.push(...empList);
        this.pageCount();
      }
    },

    async pageCount(){
      let startEmployee = (this.currentPage - 1) * this.itemsPerPage + 1;
      let endEmployee = Math.min(this.currentPage * this.itemsPerPage, this.totalEmployees);
      this.employeePageCount = `${startEmployee}-${endEmployee}/${this.totalEmployees}` 
    },

    async filterOnChange(val) {
      try {
        if(val) {
          let payload = {
            le_id: this.le_id,
            key: val
          }
          let response = await this.fetch_searched_employee(payload);
          if(response.data && response.data.status) {
            let empList = [];
            this.employeeData = [];
            for (let employee of response.data.payload.data) {
              employee["name"] = employee.first_name;
              employee["code"] = employee.code;
              employee["email"] = employee.email_id;
              employee["showDropDown"] = false;
              employee["empSalarySettings"] = employee.EmployeeSalarySetting;
              employee["email"] = employee.email_id;
              employee["currCtc"] =
              employee.EmployeeSalarySetting[0].master_salary_structure.ctc;
              if (employee.EmployeeSalarySetting[0].history_salary_structure) {
                employee["totRevision"] = employee.EmployeeSalarySetting[0].history_salary_structure.length;
                employee["reviseSalary"] = [];
                employee["effectiveDate"] = [];
                for (let historyObj of employee.EmployeeSalarySetting[0].history_salary_structure) {
                  employee["reviseSalary"].push(historyObj.ctc);
                  employee["effectiveDate"].push(historyObj.from);
                }
              }
              empList.push(employee);
            }
            this.employeeData.push(...empList);
            this.employeePageCount = `${this.employeeData.length}/${this.totalEmployees}` 
          }
        } else {
          this.employeeData = [...this.tempArrayList];
          this.pageCount();
        }
        // let tempArray = [];
        // this.tempArrayList.forEach(element => {
        //   if (element.name) {
        //     if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
        //       tempArray.push(element);
        //     }
        //   }
        //   if (element.code) {
        //     if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
        //       tempArray.push(element);
        //     }
        //   }
        // });
        // if (val) {
        //   console.log(tempArray,">>>>>>>>>>>>>>>>>>>>>>>")
        //   this.employeeData = tempArray;
        // } else {
        //   this.employeeData = [...this.tempArrayList];
        // }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async filterOnblur(val){
      try {
        if(val) {
          let payload = {
            le_id: this.le_id,
            key: val
          }
          let response = await this.fetch_searched_employee(payload);
          if(response.data && response.data.status) {
            let empList = [];
            this.employeeData = [];
            for (let employee of response.data.payload.data) {
              employee["name"] = employee.first_name;
              employee["code"] = employee.code;
              employee["email"] = employee.email_id;
              employee["showDropDown"] = false;
              employee["empSalarySettings"] = employee.EmployeeSalarySetting;
              employee["email"] = employee.email_id;
              employee["currCtc"] =
              employee.EmployeeSalarySetting[0].master_salary_structure.ctc;
              if (employee.EmployeeSalarySetting[0].history_salary_structure) {
                employee["totRevision"] = employee.EmployeeSalarySetting[0].history_salary_structure.length;
                employee["reviseSalary"] = [];
                employee["effectiveDate"] = [];
                for (let historyObj of employee.EmployeeSalarySetting[0].history_salary_structure) {
                  employee["reviseSalary"].push(historyObj.ctc);
                  employee["effectiveDate"].push(historyObj.from);
                }
              }
              empList.push(employee);
            }
            this.employeeData.push(...empList);
            this.employeePageCount = `${this.employeeData.length}/${this.totalEmployees}` 
          }
        } else {
          this.employeeData = [...this.tempArrayList];
          this.pageCount();
        }
        // let tempArray = [];
        // this.tempArrayList.forEach(element => {
        //   if (element.name) {
        //     if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
        //       tempArray.push(element);
        //     }
        //   }
        //   if (element.code) {
        //     if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
        //       tempArray.push(element);
        //     }
        //   }
        // });
        // if (val) {
        //   this.employeeData = tempArray;
        // } else {
        //   this.employeeData = [...this.tempArrayList];
        // }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    setConstantsData() {
      try {
        this.criteriaList = constants.ReviseSalaryConstants.criteriaList;
        this.statusList = constants.ReviseSalaryConstants.statusList;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async fetchAllPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.payGroupData = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    searchBand(searchText) {
      this.searchText = searchText;
    },
    dropdown(slots) {
      try {
        let idx = this.employeeData.findIndex(obj => {
          return obj.id == slots.id;
        });
        this.employeeData.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.employeeData[idx].showDropDown = this.employeeData[idx]
            .showDropDown
            ? false
            : true;
          this.employeeData = [...this.employeeData];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    viewHistory(record) {
      this.$emit("historyCheck", record);
    },
    reviseseSalary(record) {
      this.$emit("swichTab", 0, record);
      this.$emit("reviseSalary", record);
    },
     RevokeReviseSalary(record) {
      //this.showRevokeRevisePopup= true;
      //console.log("checking whats comming",record);
     // this.$emit("RevokeReviseSalary", record);
     this.tempRecord=record;
     this.showWarningMsg = true;
    // this.confirm(record);

    },
    confirm() {
      this.showWarningMsg = false;
      this.performAction(this.tempRecord);
    },
    async performAction(tempRecord){

      let res = await this.act_revoke_revise_salary({id:tempRecord.EmployeeOfficial.employee_id});
      if(res.status == 200 ){
        //console.log("lets check response",res);

              this.showRevokeRevisePopup = true;
              //this.fetchEmplDetails();
      }else{
        this.failuremsg = true;
      }


    },
    cancel() {
      this.showWarningMsg = false;
    },
      backToSalaryDataPage() {
        this.showRevokeRevisePopup = false;
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });

    },

    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        this.gradeList = [];
        if (res.data.status) {
          this.gradeList = res.data.payload.data;
        };
        this.subCriteriaList = this.gradeList;
        this.subCriteriaList = [...this.subCriteriaList];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        this.locationList = [];
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        };
        this.subCriteriaList = this.locationList;
        this.subCriteriaList = [...this.subCriteriaList];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        this.bandList = [];
        if (res.data.status) {
          this.bandList = res.data.payload.data;
        };
        this.subCriteriaList = this.bandList;
        this.subCriteriaList = [...this.subCriteriaList];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.departmentList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.costCenterList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        this.designationList = [];
        if (res.data.status) {
          this.designationList = res.data.payload.data;
        }
        this.subCriteriaList = this.designationList;
        this.subCriteriaList = [...this.subCriteriaList];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getEmpCategoryList() {
      try {
        let res = await this.fetch_empCategories(this.le_id);
        if (res.data.status) {
          this.categoryList = res.data.payload.data;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.firstPage = false;
        this.currentPage = pageNumber;
        this.fetchEployees();
      }
    },
    onChangeCriteria(event) {
      try {
        this.subCriteria = [];
        if (event) {
          let eventName = event.name;
          this.filterData.criteria = null;
          switch (eventName) {
            case "Designation":{
              if (!this.designationList.length){
                this.getDesignations();
              }
            }
              break;
            case "Grades":{
              if (!this.gradeList.length){
                this.getGrades();
              }
            }
              break;
            case "Bands":{
              if (!this.bandList.length){
                this.getBands();
              }
            }
              break;
            case "Location":{
              if (!this.locationList.length){
                this.getLocations();
              }
            }
              break;
            default:
              this.subCriteriaList = [];
              this.subCriteriaList = [...this.subCriteriaList];
              break;
          }
        } else {
          this.subCriteriaList = [];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.reviseSalaryValue = data.data.user.permissions.revise_salary ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/_variables.scss";
.uploadMethoRadio {
  display: flex;
}
.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}
.table-div {
  min-height: 350px;
  max-height: 500px;
  overflow: auto;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

/* Modal Content */
.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }

  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: 14px;
    margin-bottom: auto;
  }

  .effDateClass {
    margin-bottom: 5%;
  }
  .popup-btns {
    display: flex;
    :nth-child(n) {
      margin-right: 15px;
    }
  }
}
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.lop-report {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.3fr auto;
  grid-gap: 10px;
}
.export-emp {
  float: right;
  margin-bottom: 1%;
  margin-top: 3%;
}
.export-section {
  margin-left: 12%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 85px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 5px;
  margin-right: 10px;
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.cardClass {
  margin-bottom: 2%;
}
.download-btn {
  margin-top: 2%;
}
.customwidth {
  width: 245px;
}
.details {
  color: #979797;
  font-size: 11px;
  b {
    color: #535353;
  }
}
.width-160{
  width: 160px;

}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.bulkCTC{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #34c0be;
  font-weight: 600;
}

.bulkCTC > span{
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
</style>
